if (!customElements.get('collection-list')) {
  class CollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.collection-list__items',
        pagination: '.swiper-pagination',
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
      };
      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.enableSlider = this.dataset.enableSlider === 'true';
      this.items = parseInt(this.dataset.items, 10);
      this.tabletItems = parseInt(this.dataset.tabletItems, 10);

      this.sliderInstance = false;
      this.dragScrollInstance = null;
      this.boundFocusHandlers = [];
      this.focusableElements = [];

      if (!this.enableSlider) return;

      this.init();
      document.addEventListener('matchMobile', () => {
        this.init();
      });
      document.addEventListener('unmatchMobile', () => {
        this.init();
      });
    }

    init() {
      if (FoxTheme.config.mqlMobile) {
        this.destroySlider();
      } else {
        this.initSlider();
      }
    }

    initSlider() {
      const columnGap = window
        .getComputedStyle(this.sliderWrapper)
        .getPropertyValue('--column-gap');
      const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

      const sliderOptions = {
        modules: [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination],
        slidesPerView: this.tabletItems > 3 ? 3 : parseInt(this.tabletItems, 10),
        spaceBetween: spaceBetween,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        pagination: false,
        breakpoints: {
          1280: {
            slidesPerView: parseInt(this.items, 10),
          },
        },
        loop: false,
        initialSlide: 0,
        threshold: 2,
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        // Initialize drag-to-scroll functionality
        if (window.FoxTheme.CollectionDragScroll) {
          this.dragScrollInstance = new window.FoxTheme.CollectionDragScroll(
            this,
            this.sliderInstance
          );
        }

        this.focusableElements = FoxTheme.a11y.getFocusableElements(this);

        this.focusableElements.forEach((element) => {
          const handler = () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          };
          this.boundFocusHandlers.push(handler);
          element.addEventListener('focusin', handler);
        });
      }

      if (
        Shopify.designMode &&
        typeof this.sliderInstance === 'object' &&
        !this.boundShopifyBlockSelect
      ) {
        this.boundShopifyBlockSelect = (e) => {
          // Compared as strings because the event detail carries the section id
          // as a string while this.sectionId may be a number, which is what the
          // loose comparison here was relying on.
          if (String(e.detail.sectionId) !== String(this.sectionId)) return;
          const { target } = e;
          const index = Number(target.dataset.index);

          this.sliderInstance.slider.slideTo(index);
        };
        document.addEventListener('shopify:block:select', this.boundShopifyBlockSelect);
      }
    }

    destroySlider() {
      if (typeof this.sliderInstance === 'object') {
        // Destroy drag-to-scroll instance first
        if (this.dragScrollInstance) {
          this.dragScrollInstance.destroy();
          this.dragScrollInstance = null;
        }

        // Remove focus event listeners to prevent memory leaks
        if (this.focusableElements && this.boundFocusHandlers) {
          this.focusableElements.forEach((element, index) => {
            if (this.boundFocusHandlers[index]) {
              element.removeEventListener('focusin', this.boundFocusHandlers[index]);
            }
          });
          this.boundFocusHandlers = [];
        }

        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }

    disconnectedCallback() {
      if (this.boundShopifyBlockSelect) {
        document.removeEventListener('shopify:block:select', this.boundShopifyBlockSelect);
      }
      this.destroySlider();
    }
  }
  customElements.define('collection-list', CollectionList);
}
